import "./Spinner.scss"

import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"
import { Flex } from "components/Flex"

import spinnerImg from "assets/img/spinner.svg"

interface ISpinnerProps {
    size?: number,
    className?: string
}

const Spinner: FunctionComponent<React.PropsWithChildren<ISpinnerProps>> = ({
    size,
    className = ""
}) => {
    const { t } = useTranslation()
    return (
        <Flex className={` h-100 ${className}`}
            alignItems="center"
            justifyContent="center"
            data-testid="spinner">
            <div className="spinner"
                role="progressbar">
                <img
                    src={spinnerImg}
                    width={size}
                    className="spinner__img"
                    alt={t('common.loading')}
                    aria-hidden />
            </div>
        </Flex>
    )
}

export default Spinner
